import { react2panel } from 'common/util/react2panel';
import { PropertiesMenuReact } from './index';
export const PropertiesMenuEl = react2panel("mp-properties-menu", PropertiesMenuReact);